<script lang="ts">
  import type { Conversation } from '../../shared/types';
  import type { CallController } from '../call.svelte';
  import Icon from './Icon.svelte';
  import VideoTile from './VideoTile.svelte';

  interface Props {
    call: CallController;
    conversation: Conversation;
    onClose: () => void;
  }

  let { call, conversation, onClose }: Props = $props();

  const activeCamera = $derived(call.cameras.find((camera) => camera.deviceId === call.activeCameraId));
  const switchTitle = $derived(
    !call.camera
      ? 'Turn on the camera to switch cameras'
      : !call.canSwitchCamera
        ? 'Only one camera is available'
        : activeCamera?.facing === 'user'
          ? 'Switch to back camera'
          : 'Switch to front camera',
  );
</script>

<div class="call-panel">
  <div class="call-head">
    <span class="live-dot"></span>
    <strong>{call.connected ? 'In call' : call.status === 'connecting' ? 'Connecting…' : 'Call'}</strong>
    <span class="call-room">{conversation.title}</span>
    <button class="icon-btn" onclick={onClose} aria-label="Close call">
      <Icon name="close" size={18} />
    </button>
  </div>

  {#if call.error}
    <div class="call-error">{call.error}</div>
  {/if}

  <div class={`tiles ${call.tiles.length <= 1 ? 'single' : ''}`}>
    {#each call.tiles as tile (tile.id)}
      <VideoTile {tile} />
    {/each}
    {#if !call.tiles.length}
      <div class="call-hint">Waiting for participants…</div>
    {/if}
  </div>

  <div class="call-controls">
    <button class={`ctrl ${call.mic ? '' : 'off'}`} onclick={() => void call.toggleMic()} title="Microphone">
      <Icon name={call.mic ? 'mic' : 'micOff'} />
    </button>
    <button class={`ctrl ${call.camera ? '' : 'off'}`} onclick={() => void call.toggleCamera()} title="Camera">
      <Icon name={call.camera ? 'video' : 'videoOff'} />
    </button>
    <button
      class="ctrl"
      onclick={() => void call.switchCamera()}
      disabled={!call.camera || !call.canSwitchCamera || call.switchingCamera}
      title={switchTitle}
      aria-label={switchTitle}
    >
      <Icon name="switchCamera" />
    </button>
    <button class={`ctrl ${call.screen ? 'on' : ''}`} onclick={() => void call.toggleScreen()} title="Share screen">
      <Icon name="screen" />
    </button>
    <button class="ctrl hangup" onclick={onClose} title="Leave call">
      <Icon name="phoneOff" />
    </button>
  </div>
</div>
